<div class="bg-[#FAFAFA] min-h-screen">
  @if (isLoading) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <i class="pi pi-spin pi-spinner text-3xl text-[#2563eb]"></i>
    </div>
  } @else if (hasError) {
    <div class="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <i class="pi pi-exclamation-triangle text-4xl text-red-500"></i>
      <p class="font-roboto text-[#6D6D72] text-base">No se pudo cargar el documento. Intenta de nuevo más tarde.</p>
    </div>
  } @else {
    <article class="max-w-[860px] mx-auto px-6 md:px-12 pt-[calc(60px+3rem)] pb-24 legal-content">
      <markdown [data]="markdownContent"></markdown>
    </article>
  }
</div>
